const MAIN_RED = "#c55c52";
const MAIN_GREEN = "#00636C";
//import * as Sentry from "@sentry/vue";

export default {
  createError({ commit }, error) {
    //Sentry.captureException(error); <- these are mostly thrown errors by our functions, not very much helpful in sentry

    commit("SET_SNACKBAR_COLOR", MAIN_RED);
    commit(
      "SET_SNACKBAR_TEXT",
      error?.text ??
        "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal"
    );
    commit("SET_SNACKBAR", true);
  },
  createSuccess({ commit }, successMessage) {
    commit("SET_SNACKBAR_COLOR", MAIN_GREEN);
    commit("SET_SNACKBAR_TEXT", successMessage);
    commit("SET_SNACKBAR", true);
  },
  setSnackbar({ commit }, value) {
    commit("SET_SNACKBAR", value);
  },
  setSelectedPrincipal: ({ commit, state }, newValue) => {
    commit("SET_SELECTED_PRINCIPAL", newValue);
    return state.selectedPrincipal;
  }
};
